import { VariantOption } from 'dragonmouse-shared/variants';

// Axes for the variants panel. Empty on main by contract: exploration branches
// declare their axes here (keys [a-z0-9-]+, labels[0] describing the proposed
// default) and a non-empty manifest never merges to main — the empty manifest
// is what keeps the panel and the x-variants header inert in real builds.
// The key 'panel' is reserved: ?variants=panel:0 hides the panel itself.
export const VARIANT_OPTIONS: VariantOption[] = [];
